export const RESONANCE_URL = 'https://resonance.sustefy.com'; // TODO: confirm final URL with Barbara
export const CONTACT_EMAIL_GENERAL = 'info@sustefy.com';
export const CONTACT_EMAIL_ADVISORY = 'daniel.vanwassem@sustefy.com';
